<template>
	<div class="zz_header_bar">
		<div class="zz_header_mbox">
			<div class="zz_header_mlogo cl">
				<img src="@/assets/index/head01s.png" style="height: 30px;" alt="">
				<img src="@/assets/index/head02s.png" alt="" style="margin-left: 10px;height: 20px;margin-top: 10px;">
			</div>
			<div class="urldizhi">
				<div class="urldizhis"  @click="rou('/')">门户</div>
				<div class="urldizhis" :class="[path=='/forum'?'selectcl':'']" @click="rou('/forum')">论坛</div>
				<div class="urldizhis" :class="[path=='/boke'?'selectcl':'']" @click="rou('/boke')">博客</div>
			</div>
			<!--消息通知-->
			<el-dropdown style="position: absolute;right: 200px;top:20px;"  @command="handleCommand" v-if="token">
				<div style="color: #333;cursor: pointer;position: relative;">
				消息
				<div class="hongdian" v-if="notice.num>0"></div>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item class="dropdowns" command="1">
						评论
						<div class="hongdians" v-if="notice.type01>0" style="top: 10px;right: 40px;"></div>
					</el-dropdown-item>
					<el-dropdown-item class="dropdowns" command="2">
						博客
						<div class="hongdians" v-if="notice.type02>0" style="top: 10px;right: 40px;"></div>
					</el-dropdown-item>
					<el-dropdown-item class="dropdowns" command="3">
						帖子
						<div class="hongdians" v-if="notice.type03>0" style="top: 10px;right: 40px;"></div>
					</el-dropdown-item>
					<el-dropdown-item class="dropdowns" command="4">
						系统通知
						<div class="hongdians" v-if="notice.type04>0" style="top: 10px;right: 10px;"></div>
					</el-dropdown-item>
				  </el-dropdown-menu>
			</el-dropdown>
				<!--消息通知-->
			<div class="zz_header_right">
				<i class="el-icon-search" @click="rou('/search')"></i>
				<el-button type="text" id="loginDialog" @click="login" v-if="!token">
					<span style="color: #666;font-weight: 400;font-size: 14px;">
						登录
					</span>
				</el-button>
				<!--登录状态下显示头像-->
				<el-popover
				  v-if="token"
				  placement="bottom"
				  width="260"
				  style="margin-left: 20px;"
				  trigger="hover">
				  <div class="qianru">
					  <!--头像昵称-->
					<div class="zz_hmr_um1 cl">
						<div class="zhanzhuai-hd-uesr cl">
							<div class="zz_hmr_um1z">
								<img :src="headimgurl" alt="">
							</div>
							<div class="zz_hmr_um1y">
								<div class="zz_hmr_um_title">
									<span>{{nickname}}</span>
								</div>
							</div>
						</div>
					</div>
					<!--退出登录-->
					<div class="zz_hmr_um4 cl">
						<el-button type="primary" size="small" @click="rou('/neirong')">
							管理中心
						</el-button>
						<el-button type="danger" size="small" @click="tuichu">
							退出登录
						</el-button>
					</div>
				  </div>
				  <div class="avatar" slot="reference">
					  <img :src="headimgurl" alt="">
				  </div>
				</el-popover>
				<!--登录状态下显示头像-->
			</div>
		</div>
		
        <!--微信登录-->
		<erlogin ref="logindata"></erlogin>
	</div>
</template>

<script>
	import erlogin from "./erlogin.vue"
	import { mapGetters } from 'vuex'
	import { getQueryVariable } from "@/utils/rules"
	import { getToken } from '@/utils/auth'
	import Vue from 'vue'
	export default {
		components:{
			erlogin
		},
		computed: mapGetters([
			"nickname","headimgurl","token","notice"
		]),
		data(){
			return{
				userinfo:null,
				type:2,
				path:"/portal"
			}
		},
		watch:{
		  $route(to,from){
			  console.log('too',to);
			  this.path = to.path
			this.wxlogin();
			this.$store.dispatch('user/noticeinfo');//获取消息
		  }
		},
		mounted(){
		   let that = this;
		   that.path = this.$route.path
		       this.$nextTick(()=>{
				   window.loginEvent = new Vue();
				   loginEvent.$on("loginDialogEvent",function(){
				    that.$refs.logindata.show()
				   })
			   })
			   console.log("getToken()",getToken());
		   if(getToken()){
		   	  this.$store.dispatch('user/getInfo');
			  this.$store.dispatch('user/noticeinfo');//获取消息
		   }
		},
		methods:{
			rou(url){
				this.$router.push({
					path:url
				})
			},
			handleCommand(type){
				this.$router.push({
					path:"/neirong",
					query:{
						activeName:'ten',
						type:type
					}
				})
				console.log(this.$route);
				if(this.$route.path=="/neirong"){
					location.reload();
				}
			},
			user_xiaoxi_num(){
				user_xiaoxi_num({}).then(res=>{
					console.log("消息列表",res.data);
					this.notice = res.data
				}).catch(()=>{
					
				})
			},
			wxlogin(){
			  let that = this;
			  let code = this.$route.query.code?this.$route.query.code:null;
			  console.log("code",code,this.$route);
			  //如果code存在并且缓存中没有token则进行登录
			  if(code && !getToken()){
				  that.$refs.logindata.hide();
				  that.$store.dispatch('user/login', {code:code})
					.then(() => {
						 that.$store.dispatch('user/getInfo').then(()=>{
							 that.$router.push({ path: this.$route.path || '/', query: that.$route.query })
						 })
					})
					.catch(() => {
					})
			  }
			  //获取个人信息
			  if(getToken()){
				  that.$store.dispatch('user/getInfo');
			  }
					  
			},
			//登录
			login(){
				this.$refs.logindata.show()
			},
			async tuichu(){
			  await this.$store.dispatch('user/logout')
			  this.$router.push({ path: this.$route.path || '/', query: this.$route.query })
			  window.location.reload()
			},
		},
	}
</script>

<style lang="scss" scoped>
	//消息通知
	.dropdowns{
		position: relative;
	}
	.hongdians{
		width: 5px;
		height: 5px;
		background: #fc5531;
		border-radius: 50%;
		position: absolute;
	
	}
	.hongdian{
		width: 8px;
		height: 8px;
		background: #fc5531;
		border-radius: 50%;
		position: absolute;
		top: -2px;
		right: -7px;
	}
	//消息通知
	.urldizhi{
		display: flex;
		align-items: center;
		height: 100%;
		width: 210;
		position: absolute;
		left: 50%;
		margin-left: -105px;
		.urldizhis{
			width: 70px;
			font-size: 15px;
			color: #34495e;
			cursor: pointer;
		}
		.urldizhis:hover{
			color: #fc7247;
		}
	}
	.selectcl{
		color: #fc7247!important;
	}
	.el-icon-search{
		color: #a8afbb;
		font-size: 20px;
		margin-right: 40px;
		cursor: pointer;
	}
	.el-icon-search:hover{
		color: #fc7247;
	}
	.zz_hmr_um4{
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
	.zz_hmr_um3{
		margin-top: 15px;
		padding: 10px 0;
		background: #fafafa;
		border: 1px solid #f0f0f0;
		overflow: hidden;
		ul{
			width: 200px;
			margin: 0 auto;
			font-size: 12px;
			overflow: hidden;
			li{
				width: 180px;
				cursor: pointer;
				height: 25px;
				overflow: hidden;
				float: left;
				text-align: center;
				line-height: 25px;
				color: #333;
			}
		}
	}
	.qianru{
		width: 100%;
		.zz_hmr_um1{
			width: 230px;
			min-height: 54px;
			line-height: 25px;
			//padding: 15px;
			text-align: center;
			overflow: hidden;
			zoom: 1;
			.zz_hmr_um1y{
				height: 43px;
				padding-top: 6px;
				text-align: left;
				overflow: hidden;
				.zz_hmr_um_title{
					height: 20px;
					line-height: 20px;
					display: block;
					overflow: hidden;
					zoom: 1;
					span{
						font-size: 14px;
						    color: #333;
						    font-weight: 700;
						    display: inline;
					}
				}
			}
			.zz_hmr_um1z{
				float: left;
				width: 54px;
				height: 54px;
				margin-right: 12px;
				overflow: hidden;
				background: #ececec;
				img{
					width: 48px;
					height: 48px;
					padding: 2px;
					background: #FFF;
					border: 1px solid;
					border-color: #F2F2F2 #CDCDCD #CDCDCD #F2F2F2;
					border-radius: 5px;
				}
			}
		}
	}
	.avatar{
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background: #ececec;
		position: absolute;
		right: 0px;
		top: 50%;
		margin-top: -15px;
		cursor: pointer;
		img{
			width: 100%;
			height: 100%;
			border-radius: 50%;
			position: absolute;
			left: 0px;
			top: 0px;
		}
	}
	.zz_header_bar{
		width: 100%;
		height: 60px;
		
		.zz_header_mbox{
			position: relative;
			width: 100%;
			min-width: 1200px;
			height: 100%;
			background: #fff;
			box-shadow:0 1px 2px 0 #ececec;
			z-index: 199;
			display: flex;
			.zz_header_right{
				position: absolute;
				height: 100%;
				line-height: 65px;
				top: 0px;
				right: 80px;
				display: flex;
				align-items: center;
			}
			.zz_header_mlogo{
				position: absolute;
				left: 80px;
				height: 100%;
				top: 0;
				margin-right: 10px;
				overflow: hidden;
				display: flex;
				align-items: center;
				img{
					height: 40px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Lhead.vue